import type { CollectionNames } from '@/api/clients/directus-client'
import type { DirectusDriver } from '@/types/directus-types'
import { directusReadOne } from './helperFunctions'

const collectionName: CollectionNames = 'Driver'
const query = {
  fields: ['id', 'Name', 'Driving', 'ProfilePic', 'Bio'],
}

/**
 * Fetches an individual driver record based on the passed id.
 *
 * @param driverId the id of the users driver record
 * @returns a user `DriverData` object if successful. Undefined if not.
 */
export async function fetchDriverData(driverId: number): Promise<DirectusDriver | undefined> {
  return await directusReadOne<DirectusDriver>(collectionName, driverId, query)
}
